import React from 'react';
import { ThemeProvider } from './context/ThemeContext';
import { AuthProvider } from './context/AuthContext';
import { ErrorBoundary, AppRoutes } from './components';
import { StelaNav } from './components/StelaNav';
import { Toaster } from 'sonner';

const App: React.FC = () => {
  return (
    <ErrorBoundary>
      <AuthProvider>
        <ThemeProvider>
          <div className="min-h-screen relative bg-stela-ink text-stela-fg">
            <StelaNav />
            <main>
              <AppRoutes />
            </main>
            <Toaster position="top-center" />
          </div>
        </ThemeProvider>
      </AuthProvider>
    </ErrorBoundary>
  );
};

export default App;